import React, { useEffect, Fragment } from "react";
import ReactTable from "react-table";
import StatusOverlay from "../../StatusOverlay";
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router";

const ConsolidatedBilling = props => {
  const {
    member,
    consolidatedBilling,
    doFetchGetConsolidatedBilling,
  } = props
  const { childAccounts } = consolidatedBilling;

  const columns = [
    {
      Header: "Account ID",
      accessor: "account_id",
    },
    {
      Header: "Member ID",
      accessor: "member_id",
      Cell: ({ value }) => (
        <div style={{ textAlign: "center" }}>
          <Link
            to={`/members/${value}/details`}
            activeStyle={{
              textDecoration: "none",
              color: "black",
              position: "abosolute",
              right: 0,
            }}
            component="button"
          >
            {value}
          </Link>
        </div>
      )
    },
    {
      Header: "Account Number",
      accessor: "account_number",
    },
    {
      Header: "Active",
      accessor: "active",
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value ? 'Yes' : 'No'}</div>)
    },
    {
      Header: "Statement Generated",
      accessor: "is_statement_generated",
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value ? 'Yes' : 'No'}</div>)
    },
  ]

  useEffect(() => {
    if (member && member.get("accountID")) {
      doFetchGetConsolidatedBilling(member.get("accountID"))
    }
  }, [member])

  return (
    <div>
      <Grid container>
        <Grid item sm={6}>
          <h4>Consolidated Billing</h4>
        </Grid>
      </Grid>
      <br />
      <div>
        {
          childAccounts && childAccounts.length > 0 ? (
            <Fragment>
              <ReactTable
                data={childAccounts}
                columns={columns}
                style={{ textAlign: 'center' }}
                className="-striped -highlight"
                defaultPageSize={10}
                defaultSortDesc
                default
              />
            </Fragment>
          ) : (
            <div>
              There are no consolidated billing
            </div>
          )
        }
        <StatusOverlay />
      </div>
    </div>
  )
}

export default ConsolidatedBilling
